import React, { useEffect, useState } from 'react'
import { useFindMenu, useTrans } from '@next-nx/hooks'
import { WContainer, Breadcrumbs, MainTitle, Button, Dropdown } from '@next-nx/shared-ui/atoms'
import { ImageTextBanner, Page } from '@next-nx/shared-ui/organisms'
import { ArticoloCard } from '@next-nx/shared-ui/molecules'
import styles from './NewsListingTemplate.module.sass'
import { NEWS_LISTING_ITEMS_PER_PAGE } from '@next-nx/utils/settings'
import { useAllNewsLazyQuery } from '@next-nx/shared-graphql/unipolrental'
import FiltersTriangle from '../../atoms/Icons/FiltersTriangle'

interface Props {
  className?: string
  pagina: any
  allNews: any
}

const NewsListingTemplate = (props: Props) => {
  const { className = '', pagina = {}, allNews = undefined } = props

  const newsMenu = useFindMenu('pagina-news')
  const boxNews = useFindMenu('box-news', newsMenu)
  const t = useTrans()

  const ordinamenti = [
    { value: 'data_pubblicazione', label: t('Meno recente') },
    { value: '-data_pubblicazione', label: t('Più recente') },
  ]

  const [ordinamentoSelected, setOrdinamentoSelected] = useState(ordinamenti[1])
  const [news, setNews] = useState(allNews)
  const [getAllNews, { data }] = useAllNewsLazyQuery()

  const handleOrdinamento = (v) => {
    const newOrdinamentoSelected = ordinamenti.find((o) => o.value === v) || ordinamentoSelected
    setOrdinamentoSelected(newOrdinamentoSelected)

    getAllNews({
      variables: {
        orderBy: newOrdinamentoSelected?.value,
      },
    })
  }
  const [numItems, setNumItems] = useState(NEWS_LISTING_ITEMS_PER_PAGE)

  useEffect(() => {
    if (data) {
      setNews(data)
    }
  }, [data])

  const newsToShow = news?.allNews.edges.filter((n, i) => i < numItems)

  return news && news.allNews ? (
    <Page pagina={pagina} className={`${styles.root}`}>
      <WContainer>
        <Breadcrumbs breadcrumbs={pagina.breadcrumbs} className={styles.breadcrumbs} />
        <MainTitle label={pagina?.titolo} className={styles.title} />
        <div className={styles.list}>
          <div className={styles.articoliTotali}>
            {news.allNews.edges.length} {t('articoli totali')}
          </div>
          <Dropdown
            icon={<FiltersTriangle />}
            label={t('Ordina per: {0}', [ordinamentoSelected.label])}
            options={ordinamenti}
            value={ordinamentoSelected.value}
            setValue={(v) => handleOrdinamento(v)}
            highlightOnCompiled={false}
            dropdownVariant="arrow"
            className={styles.listOrder}
          />
        </div>
        <div className={styles.listing}>
          {news.allNews.edges
            .filter((n, i) => i < numItems)
            .map(
              (n) =>
                n?.node && (
                  <div className={styles.item} key={n.node.pk}>
                    <ArticoloCard news={n.node} withDataPubblicazione />
                  </div>
                )
            )}
        </div>
        <div className={styles.ordinamenti}>
          <p>
            {t('Hai visualizzato {0} articoli di {1}', [
              newsToShow.length,
              news.allNews.edges.length,
            ])}
          </p>

          {numItems < news.allNews.edges.length && (
            <Button
              onClick={() => setNumItems(numItems + NEWS_LISTING_ITEMS_PER_PAGE)}
              label={t('Carica altri')}
              color={'blue'}
            />
          )}
        </div>
      </WContainer>
      {!!boxNews && <ImageTextBanner className={styles.BoxNews} item={boxNews}></ImageTextBanner>}
      <WContainer></WContainer>
    </Page>
  ) : (
    <></>
  )
}

export default NewsListingTemplate
